export default () => ({

    copied: false,

    copyToClipboard(text){
        
        const self = this;
        navigator.clipboard.writeText(text).then(function() {                
            self.copied = true;

            setTimeout(()=> {
                self.copied = false;
            }, 2000);
        });

    }

})